import algoliaSearch from "algoliasearch/lite";

const REACT_APP_ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const REACT_APP_ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;

export const searchClient = algoliaSearch(
  REACT_APP_ALGOLIA_APP_ID,
  REACT_APP_ALGOLIA_API_KEY,
);